/**
 * SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
 * Copyright (C) 2022 SuiteCRM Ltd.
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License version 3 as published by the
 * Free Software Foundation with the addition of the following permission added
 * to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
 * IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
 * WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 *
 * In accordance with Section 7(b) of the GNU Affero General Public License
 * version 3, these Appropriate Legal Notices must retain the display of the
 * "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
 * feasible for technical reasons, the Appropriate Legal Notices must display
 * the words "Supercharged by SuiteCRM".
 */
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class BaseRouteService {

    constructor() {
    }

    /**
     * Calculate Base Route
     *
     * @returns {string}
     * @param url
     */
    public calculateRoute(url): string {
        const path = window.location.pathname;

        if (path.includes('index.php')) {
            url = `${path}/${url}`;
        }
        return url;
    }

    /**
     * Append auth path
     * @param url
     */
    public appendNativeAuth(url: string): string {
        const path = window.location.pathname;

        if (path.includes('auth')) {
            url = `auth/${url}`
        }

        return url;
    }

    /**
     * Remove native auth from path name
     */
    public removeNativeAuth(): string {
        let url = window.location.pathname;

        if (url.includes('/auth')) {
            url = url.replace('/auth', '/');
        }

        url = url.replace('//', '/');

        return url;
    }

    /**
     * Is native auth
     */
    public isNativeAuth(): boolean {
        const path = window.location.pathname;

        return path.includes('auth');
    }

    /**
     * Get native auth logout url
     */
    public getNativeOutLogoutUrl(): string {

        return `auth/logout`;
    }

    /**
     * Is logged out page
     */
    public isLoggedOutPath(): boolean {
        const path = window.location.pathname;

        return path.includes('logged-out');
    }
}
